import { defineMessages } from 'react-intl';

const senderFieldMessages = defineMessages({
    emailLabel: {
        id: 'sender.senderFieldMessages.emailLabel',
        description: 'Label text for card sender email input',
        defaultMessage: 'Your email'
    },
    emailHelper: {
        id: 'sender.senderFieldMessages.emailHelper',
        description: 'Helper text for card sender email input',
        defaultMessage: 'Email to send you the order confirmation.'
    },
    confirmEmailLabel: {
        id: 'sender.senderFieldMessages.confirmEmailLabel',
        description: 'Label text for card sender email input',
        defaultMessage: 'Confirm your email'
    },
    emailOptIn: {
        id: 'sender.senderFieldMessages.emailOptIn',
        description: 'Label text for the toggle to opt-in to receive marketing emails',
        defaultMessage: 'Send me information about future offers.'
    }
});

export default senderFieldMessages;
